import { REFRESH_JWT_AUTH_TOKEN } from "../queries/mutations/refreshJwtAuthToken";

import { isTokenExpired } from "../lib/helpers/isTokenExpired";
import {
  getLocalValues,
  setLocalValue,
} from "../lib/helpers/localStorageHelpers";

export const handleWooSession = (token: string | null) => {
  if (!token || token === "false" || token === "null") {
    return;
  }

  const normalized = token.replace(/^Session\s+/i, "");
  const { wooSession } = getLocalValues();

  if (!normalized || wooSession === normalized) {
    return;
  }

  setLocalValue("wooSession", normalized);
};

interface RequestHeadersType {
  authorization?: string;
  "woocommerce-session"?: string;
}

export const attachRequestHeaders = () => {
  let requestHeaders: RequestHeadersType = {};
  const { authToken, wooSession } = getLocalValues();

  if (authToken) {
    requestHeaders["authorization"] = `Bearer ${authToken}`;
  }

  if (wooSession && !isTokenExpired(wooSession)) {
    requestHeaders["woocommerce-session"] = `Session ${wooSession}`;
  }

  return requestHeaders;
};

export const getJWTRefreshToken = (): string => {
  const { refreshToken } = getLocalValues();

  return refreshToken;
};

let refreshPromise: Promise<string> | null = null;

export const getNewToken = async () => {
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const refreshToken = getJWTRefreshToken();

    if (!refreshToken || isTokenExpired(refreshToken)) {
      throw new Error("Refresh token is missing or expired");
    }

    const res = await fetch(process.env.REACT_APP_GRAPHQL_API as RequestInfo, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        variables: {
          refreshToken: refreshToken,
        },
        query: REFRESH_JWT_AUTH_TOKEN.loc?.source.body,
      }),
    });

    const json = await res.json();
    const authToken = json?.data?.refreshJwtAuthToken?.authToken;

    if (!authToken) {
      const message =
        json?.errors?.[0]?.message || "Failed to refresh auth token";
      throw new Error(message);
    }

    setLocalValue("authToken", authToken);
    return authToken;
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
};
